<template>
    <InnerLoader class="payment-loading" style="top:0;left:0;" :z-index="999" />
</template>

<script>
import InnerLoader from '@/components/InnerLoader'

export default {
    components: {
        InnerLoader
    },

    mounted() {
        const vippsUrl = new URL(location.href).searchParams.get('vippsUrl');

        if (window.opener) {
            try {
                window.location.href = atob(vippsUrl);
                window.opener.postMessage(JSON.stringify({
                    action: 'vipps-payment-start',
                    status: true
                }), '*')
            } catch (e) {
                window.opener.postMessage(JSON.stringify({
                    action: 'vipps-close-landing',
                    status: 'CLOSE',
                    message: e.message
                }), '*')
            }
        }
    }
}
</script>